import { useIntl } from "react-intl";

import ImageChecklistSide, {
    ListItemWithEmphsis
} from "../../../../../../../../patterns/image-checklist-side";

const DesignTeams = () => {
    const intl = useIntl();

    const title = intl.formatMessage({
        id: "JiraSoftwarePage.PaidLpJswPm.designTeams.headerText",
        defaultMessage: "Design teams"
    });

    const mapDependencies = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.designTeams.mapDependencies.strongtext",
            defaultMessage: "Map dependencies:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.designTeams.mapDependencies.plainText",
            defaultMessage:
                " Design teams can easily map dependencies with a timeline view. Bypass the blockers to ensure work gets done on time."
        })
    };

    const signOffFaster = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.designTeams.signoffFaster.strongtext",
            defaultMessage: "Get signoffs faster:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.designTeams.signoffFaster.plainText",
            defaultMessage:
                " Proof and comment on files directly in Jira with InVision and Figma integrations, then automatically message stakeholders via Slack, Teams, or email when it's time to get the go-ahead."
        })
    };

    const trackRequests = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.designTeams.ideationToDelivery.strongtext",
            defaultMessage: "Track requests with forms:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.designTeams.ideationToDelivery.plainText",
            defaultMessage:
                " Create an intake process in seconds that automatically creates tasks for your teams.  Keep all your requests for logos, whitepapers, landing pages in a single place."
        })
    };

    const listItems = [
        ListItemWithEmphsis(mapDependencies),
        ListItemWithEmphsis(signOffFaster),
        ListItemWithEmphsis(trackRequests)
    ];
    const imageSrc =
        "https://wac-cdn.atlassian.com/dam/jcr:3d4e2757-72e4-4482-9c91-ae62005e25aa/DESIGN%20TEAMS@2x.png?cdnVersion=ece";
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePage.PaidLpJswPm.designTeams.tabsImageAltText",
        defaultMessage: "Design teams"
    });

    const testimony = {
        isIncludeTestimony: true,
        quoteBlurb: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.designTeams.testimony.quoteBlurb",
            defaultMessage:
                "You can decide how you are working as a team first and then let the software work around you."
        }),
        quoteName: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.designTeams.testimony.quoteName",
            defaultMessage: "JEANNICE ANGELA"
        }),
        quoteCompany: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.designTeams.testimony.quoteCompany",
            defaultMessage: "PRODUCT MANAGER, RENT THE RUNWAY"
        }),
        testimonyImageClassName: "tab-testimony-image",
        testimonyImageSrc:
            "https://wac-cdn.atlassian.com/dam/jcr:44288302-8ed5-4ce2-94c0-015787b11d23/LP-logos_rent%20the%20runway%20logo.svg?cdnVersion=ece",
        testimonyImageAlt: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.designTeams.testimony.logo.imageAltText",
            defaultMessage: "Rent the Runway logo"
        })
    };

    return (
        <ImageChecklistSide
            title={title}
            listItems={listItems}
            imageSrc={imageSrc}
            imageAlt={imageAlt}
            isIncludeTestimony={testimony.isIncludeTestimony}
            quoteBlurb={testimony.quoteBlurb}
            quoteName={testimony.quoteName}
            quoteCompany={testimony.quoteCompany}
            testimonyImageClassName={testimony.testimonyImageClassName}
            testimonyImageSrc={testimony.testimonyImageSrc}
            testimonyImageAlt={testimony.testimonyImageAlt}
        />
    );
};

export default DesignTeams;
